export const PageHeaderImageElementModel = {
  position: 1,
  file: {
    base64: '',
    fileName: '',
    delete: false,
  },
};
